import type { ReactNode } from "react";
import {
  CalendarTodayOutlined,
  GroupAddOutlined,
  SellOutlined,
} from "@mui/icons-material";
import type { OverlayIcon } from "@/content/dashboardBannerOptions";
import type {
  BannerIconVisual,
  BannerImageVisual,
  BannerVisual,
} from "../templates/bannerVariants";

/** The icon drawn for each name the Studio offers. */
const BANNER_ICONS: Record<OverlayIcon, ReactNode> = {
  tag: <SellOutlined />,
  calendar: <CalendarTodayOutlined />,
  referral: <GroupAddOutlined />,
};

/** The picked icon or picture as a template draws it; nothing for none. */
export const visualOf = (
  visual: { type: "icon"; icon: OverlayIcon } | BannerImageVisual | null
): BannerVisual | undefined => {
  if (!visual) return undefined;
  if (visual.type === "image") return visual;
  return iconVisualOf(visual.icon);
};

/** The picked icon as a template draws it; nothing for none. */
export const iconVisualOf = (
  icon: OverlayIcon | null
): BannerIconVisual | undefined =>
  icon ? { type: "icon", icon: BANNER_ICONS[icon] } : undefined;
